export default __webpack_public_path__ + "static/media/cau-truc-bai-thi-dgtd-bach-khoa.15501c3b.jpg";